import { useState, useEffect, useMemo } from 'react';
import '../styles.scss';
import { Tabs, Pagination, Modal, Button, Select, Input } from 'antd';

import { EyeOutlined, SettingOutlined, FilterOutlined, FilterFilled } from '@ant-design/icons';
import { TabsProps } from 'antd/lib';
import VehicleInvoiceDetail from './VehicleInvoiceDetail';
import { formatNumber, mixGetV1 } from '../../../services/mixin';
import MegaTable from '../../../components/MagaTableV2';
import { selectorInfoUser } from '../../../store/slices/infoUserSlice';
import { selectorUnitByUserPermission } from '../../../store/slices/UnitByUserPermission';
import { useSelector } from 'react-redux';
import { filter, set } from 'lodash';

export default function VehicleInvoice({ stData = {} as any, stChange = (data: any) => { } }) {
  const user = useSelector(selectorInfoUser);
  const unitByUserPermission = useSelector(selectorUnitByUserPermission);
  const [parentUnitCode, setParentUnitCode] = useState<string>('');
  useEffect(() => {
    const findData = unitByUserPermission.find(x => x.unitId === user.unitTemp) as any
    setParentUnitCode(findData ? findData.unitCode : '')
  }, [user, unitByUserPermission]);

  useEffect(() => {
    if (parentUnitCode) {
      getUnitList(parentUnitCode)
    }
  }, [parentUnitCode]);
  const [modalFilter, setModalFilter] = useState({
    show: false,
    field: null,
    value: null,
  } as any);
  let wait3 = false
  const [unitList, setUnitList] = useState<any>([])
  const getUnitList = async (codeUnit = '') => {
    if (wait3) {
      return
    }
    wait3 = true
    const res = await mixGetV1(`unit/getChildUnits?codeUnit=${codeUnit}`);
    wait3 = false
    if (res.status) {
      setUnitList(res.data || [])
    }
  }
  const [filterActive, setFilterActive] = useState({} as any);
  const [localPage, setLocalPage] = useState(1);
  const [localLimit, setLocalLimit] = useState(10);
  const [localFilterBranchName, setLocalFilterBranchName] = useState<any>(null);
  const [localFilterChassisNo, setLocalFilterChassisNo] = useState<any>(null);

  const filteredData = useMemo(() => {
    let data = stData.vehicle_invoice_sale || [];
    if (localFilterBranchName) {
      data = data.filter((item: any) => item.branch_code === localFilterBranchName);
    }
    if (localFilterChassisNo) {
      data = data.filter((item: any) =>
        item.chassis_no?.toLowerCase().includes(localFilterChassisNo.toLowerCase())
      );
    }
    return data;
  }, [stData.vehicle_invoice_sale, localFilterBranchName, localFilterChassisNo]);

  const paginatedData = useMemo(() => {
    const start = (localPage - 1) * localLimit;
    return filteredData.slice(start, start + localLimit);
  }, [filteredData, localPage, localLimit]);

  useEffect(() => {
    setLocalPage(1);
  }, [localFilterBranchName, localFilterChassisNo, localLimit]);

  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.vehicle_owner_total_sale?.list.map((col: any) => {
      if (col.field === 'invoice_sale_total_amount' || col.field === 'unit_price') {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
          valueFormatter: (params: any) => formatNumber(params.value)
        })
      } else if (col.field === 'chassis_no' || col.field === 'branch_name') {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
          modalFilter: true,
        })
      } else if (col.field === 'contact_name') {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          cellRenderer: (params: any) => {
            return (
              <div className={params.data.contact_name_id !== 'Không xác định' && params.data.contact_name_id ? 'cus-link-detail' : ''}>
                <a className="color-bage d-none" href={`/customer/pooling-data/customer-list/detail?id_sync=${params.data.contact_name_id}`}>{params.data.contact_name}</a>
                <span className="text">{params.data.contact_name || 'Không xác định'}</span>
              </div>
            )
          },
        });
      } else {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
        })
      }
    })
    return temp
  }

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: <span className='custom-page-css font-light text-lg'>Chi tiết</span>,
      children: <VehicleInvoiceDetail stData={stData} />,
    },
  ];
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheVehicleInvoice',
    col: [
      {
        headerName: 'Hành động',
        field: 'action',
        width: 100,
        resizable: false,
        sortable: false,
        filter: false,
        lockPosition: 'left',
        cellRenderer: (params: any) => {
          return (
            <div className='d-flex gap-4 justify-start align-center  h-full'>
              <EyeOutlined
                className="text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer fs-14 border-8px"
                onClick={() => {
                  setRowActive(params?.node?.rowIndex);
                  stChange({ chitiethoadon: [{ ...params?.data }] })
                }}
              />
            </div>
          )
        },
      },
      ...tableColumns(stData.sourceColumnWarehouse),
      // { field: "contact_name", headerName: "Người đại diện" },
      // { field: "vehicle_name", headerName: "Tên xe" },
      // { field: "chassis_no", headerName: "Số khung (VIN)" },
      // { field: "plate_numbers", headerName: "Biển số xe" },
      // { field: "color_name", headerName: "Màu xe" },
      // {
      //   field: "vehicle_invoice_sale", headerName: "Tổng tiền", valueFormatter: (params: any) =>
      //     formatNumber(params.value),
      // },

      // { field: "invoice_sale_doc_no", headerName: "Số hóa đơn" },
      // { field: "contract_date", headerName: "Ngày xuất hóa đơn" },
      // { field: "branch_name", headerName: "Đơn vị mua xe" },
      // { field: "route_name", headerName: "Xưởng dịch vụ" },
    ],
    listData: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
    height: '400px',
  });
  const [rowActive, setRowActive] = useState<number>(-1);
  return (
    <>
      <div className="setting-tb-has-tab">
        <div className='settingCol'>
          <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
            <SettingOutlined />
          </div>
        </div>
      </div>
      <div className="custom-page-css w-full flex flex-col items-center justify-between gap-3 pt-3">
        <div className={` w-full`}>
          <MegaTable
            stData={{
              ...megaTableData,
              listData: paginatedData,
              rowActive,
              loading: false,
              filterActive: {...filterActive}
            }}
            stChange={(data, type) => {
              setMegaTableData((prev: any) => ({ ...prev, ...data }));
            }}
            tbChange={(data: any, type) => {
              if (type === 'modalFilter') {
                const currentValue = data.field === 'branch_name' ? localFilterBranchName : localFilterChassisNo;
                setModalFilter((prev: any) => ({ ...prev, ...data, value: currentValue }));
              }
            }}
          />
          <div className={`t-table-block t-table-customer c-table-scoll-x`}>
            <div className="pagination-block">
              <Pagination
                className='rs-pagination'
                showSizeChanger
                total={filteredData.length}
                defaultPageSize={localLimit}
                current={localPage}
                pageSizeOptions={['10', '20', '50', '100']}
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={() => `Tổng cộng ${Math.ceil(filteredData.length / localLimit) === 0 ? 1 : Math.ceil(filteredData.length / localLimit)} trang`}
                locale={{ items_per_page: 'trang' }}
                onChange={(page, pageSize) => {
                  setLocalLimit(pageSize);
                  setLocalPage(page);
                }}
              />
            </div>
          </div>
        </div>
        <div className="custom-page-css w-full flex items-center justify-between gap-3 pt-3">
          <Tabs defaultActiveKey="1" items={items} className='w-full' />
        </div>
      </div>
      <Modal
        open={modalFilter.show}
        title=''
        closeIcon={false}
        className='rs-modal footer-content-end mod-modal-filter'
        footer={
          <div className='ctr-ft-mcc'>
            <Button className="btn-reset-ft" onClick={() => {
              setModalFilter((prev: any) => ({ ...prev, value: null }))
            }}>Làm mới</Button>
            <Button
              type='primary'
              className='rs-button rs-button--sm'
              onClick={() => {
                if (modalFilter.field === 'branch_name') {
                  setLocalFilterBranchName(modalFilter.value);
                } else if (modalFilter.field === 'chassis_no') {
                  setLocalFilterChassisNo(modalFilter.value);
                }
                setModalFilter((prev: any) => ({ ...prev, show: false }))
                setFilterActive((prev: any) => ({ ...prev, [modalFilter.field]: modalFilter.value ? true : false }));
              }}
            >Xác nhận</Button>
          </div>
        }
        onCancel={() => {
          setModalFilter((prev: any) => ({ ...prev, show: false }))
        }}
      >
        {modalFilter.field === 'branch_name' &&
          <Select
            className='rs-select v2'
            placeholder='Chọn đơn vị'
            showSearch
            allowClear
            filterOption={(input, option) => {
              const normalize = (s: any) =>
                String(s ?? '')
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .replace(/đ/g, 'd')
                  .replace(/Đ/g, 'D')
                  .toLowerCase()
              const label = option?.label ?? option?.children ?? option?.value ?? ''
              return normalize(label).includes(normalize(input))
            }}
            options={unitList ? unitList.map((val: any) => ({ label: val.title, value: val.code })) : []}
            value={modalFilter.value}
            onChange={(value) => {
              setModalFilter((prev: any) => ({ ...prev, value }))
            }}
          />
        }
        {modalFilter.field === 'chassis_no' &&
          <Input value={modalFilter.value} placeholder="Nhập số khung (VIN)" onChange={(e) => {
            setModalFilter((prev: any) => ({ ...prev, value: e.target.value }))
          }} />
        }

      </Modal>
    </>
  )
}
